import { FC } from 'react';

interface STOContentProps {}

export const STOContent: FC<STOContentProps> = ({}) => {
  return (
    <div>
      <p>This would contain the detailed breakdown per channel</p>
    </div>
  );
};
